<p-toast></p-toast>

<div *ngIf="invoiceDetails && !invoiceDetails['parkingDeviceGroupID']" class="surface-100 border-round mb-3 p-3">
  <div class="flex align-items-center gap-2">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
      <span class="font-medium">The company name or group is not set for this tenant ({{queryParams.suite}} -
        {{queryParams.account}}).</span>
    </div>
    <p-button [routerLink]="['/tenant/update/'+queryParams.suite+'/'+queryParams.account]" label="Edit Tenant" [outlined]="true" severity="warning" size="small" />
  </div>
</div>

<p-messages key="api-errors"></p-messages>
<p-messages key="contact-messages"></p-messages>

<!-- Missing SUREPARK Members Action Section -->
<div *ngIf="missingSureparkMembers.length > 0" class="surface-100 border-round mb-3 p-3">
  <div class="flex align-items-center justify-content-between">
    <div class="flex align-items-center gap-2">
      <i class="pi pi-exclamation-triangle text-red-500 text-xl"></i>
      <span class="font-medium">{{ missingSureparkMembers.length }} SUREPARK member profile(s) are missing from ParkPro contacts.</span>
    </div>
    <p-button
      label="Add Missing Contacts"
      icon="pi pi-user-plus"
      [outlined]="true"
      severity="warning"
      size="small"
      (click)="openAddMissingContactsDialog()"
      [loading]="addingMissingContacts">
    </p-button>
  </div>
</div>

<div class="h-full center-container">
    <div class="grid" >
      <!-- <div class="card">
        <h1>Invoice Details</h1>
      </div> -->
      <div class="col-12">
          <div *ngIf="!loadingInvoiceDetails; else spinner">
            <form [formGroup]="invoiceForm" autocomplete="off">
              <div class="grid p-fluid mt-5">
                  <div class="field col-6 md:col-3">
                    <span class="p-float-label">
                      <input pInputText type="text" id="suite" formControlName="suite"/>
                      <label for="suite">Suite</label>
                    </span>
                  </div>
                  <div class="field col-6 md:col-3">
                    <span class="p-float-label">
                      <input pInputText type="text" id="account" formControlName="accountnumber"/>
                      <label for="account">Account</label>
                    </span>
                  </div>
                  <!-- This creates space at the end -->
                  <div class="col-6 md:col-6 hidden md:block"></div>

                  <div class="field col-12 md:col-6 ml-auto">
                    <span class="p-float-label">
                      <textarea id="billto" pInputTextarea [rows]="5" formControlName="billto" class="w-full" [cols]="55"></textarea>
                      <label for="billto">Bill To</label>
                    </span>
                  </div>

                  <!-- This creates space at the end -->
                  <div class="col-6 md:col-6 hidden md:block"></div>

                  <div class="field col-12 md:col-6">
                    <span class="p-float-label mt-3">
                      <p-dropdown
                        id="ar-type"
                        [options]="ARTypeOptions"
                        [autoDisplayFirst]="false"
                        optionLabel="name"
                        optionValue="code"
                        formControlName="type"
                        appendTo="body"
                      >
                        <ng-template let-item pTemplate="selectedItem">
                          {{ item.name }}
                        </ng-template>
                      </p-dropdown>
                      <label for="ar-type">AR Type</label>
                    </span>
                  </div>

                  <!-- This creates space at the end -->
                  <div class="col-12 md:col-6 flex align-items-center gap-2 mb-3">
                        <p-checkbox
                          formControlName="invoice_one_time_charges_only"
                          binary="true"
                          inputId="invoice-one-time-charges-only">
                        </p-checkbox>
                        <label for="invoice-one-time-charges-only" class="cursor-pointer">Only Invoice One-time Changes</label>
                  </div>

                  <div class="field col-12 md:col-6">
                    <span class="p-float-label">
                      <textarea id="invoicenotes" pInputTextarea [rows]="5" formControlName="notes" [cols]="55"></textarea>
                      <label for="invoicenotes">Notes</label>
                    </span>
                  </div>

                  <!-- This creates space at the end -->
                  <div class="col-6 md:col-6 hidden md:block"></div>

                  <div class="field col-12" *ngIf="queryParams">
                    <div class="col-12">
                      <h2>{{ invoiceForm.value['invoice_one_time_charges_only'] ? 'Line Items' : 'One-time Charges'}}</h2>
                    </div>
                    <app-invoice-line-items
                      [items]="invoiceLineItems"
                      [location]="queryParams.location"
                      [suite]="queryParams.suite"
                      [account]="queryParams.account"
                      style="width: 100%;"
                      typeToHide="NONE"
                      (invoiceLineItemsChanged)="updateLineItems($event)">
                    </app-invoice-line-items>
                  </div>
                  <div class="field col-12" *ngIf="queryParams">
                    <div class="col-12">
                      <h2>ParkPro Contacts</h2>
                    </div>
                        <div *ngIf="mergingContact else showContactList">
                          <p-progressSpinner></p-progressSpinner>
                        </div>
                        <ng-template #showContactList>
                          <app-contacts-list
                            source="attendant-portal"
                            [suite]="queryParams.suite"
                            [account]="queryParams.account"
                            (contactUpdatedEvent)="contactUpdated($event)"
                            style="width: 100%;">
                          </app-contacts-list>
                        </ng-template>
                  </div>

                  <div class="field col-12 z-0" *ngIf="queryParams">
                    <div *ngIf="mergingContact else showBillingSummary">
                          <p-progressSpinner></p-progressSpinner>
                    </div>
                    <ng-template #showBillingSummary>
                      <app-monthly-billing-summary-widget
                        [location]="queryParams.location"
                        [suite]="queryParams.suite"
                        [account]="queryParams.account"
                        [refreshSummary]="refreshBillingSummary"
                        style="width: 100%;">
                      </app-monthly-billing-summary-widget>
                    </ng-template>
                  </div>
                  <div class="col-12 px-4 text-right">
                    <h3>Monthly Charges: <span> {{ getCurrentMonthlyCharges | currency }}</span></h3>
                    <h3>One-Time Charge(s): <span> {{ getTotalOneTimeCharges | currency }}</span></h3>
                    <h3>Total Invoice Amount: <span> {{ getInvoiceTotalAmount | currency }}</span></h3>
                  </div>
                  <div class="col-12">
                    <div class="grid">
                      <div class="col-12 flex align-content-center justify-content-end gap-5">
                        <p-button label="Save Monthly Invoice Profile" (click)="saveInvoiceData()" [loading]="mergingContact || generatingInvoice" severity="success" icon="pi pi-save"></p-button>
                      </div>
                    </div>
                  </div>
              </div>
            </form>

            <!-- Developer Tools Panel - Can be toggled on/off -->
            <p-panel *ngIf="showDevTools" header="Developer Tools" styleClass="mt-3" class="w-full" [toggleable]="true" [collapsed]="false">
              <div class="grid">
                <div class="col-12">
                  <h4>Invoice Testing & Processing</h4>
                  <div class="flex gap-3 flex-wrap">
                    <p-button
                      label="Invoice This Profile - UI"
                      (click)="billMonthlyInvoice()"
                      [loading]="generatingInvoice || mergingContact"
                      icon="pi pi-file-edit"
                      pTooltip="Creates invoice using UI-generated payload">
                    </p-button>
                    <p-button
                      label="Invoice This Profile - Backend"
                      (click)="billMonthlyInvoiceBackend()"
                      [loading]="generatingInvoice || mergingContact"
                      icon="pi pi-server"
                      pTooltip="Creates invoice using backend monthly invoice process">
                    </p-button>
                    <p-button
                      label="Test Invoice (Dry Run)"
                      (click)="billMonthlyInvoiceBackend(true)"
                      [loading]="generatingInvoice || mergingContact"
                      severity="info"
                      icon="pi pi-play-circle"
                      [outlined]="true"
                      pTooltip="Simulates invoice creation without saving">
                    </p-button>
                    <p-button
                      label="Queue for Billing"
                      (click)="queueInvoiceForBilling()"
                      [loading]="generatingInvoice"
                      severity="warning"
                      icon="pi pi-clock"
                      pTooltip="Sets invoice as ready for monthly billing process">
                    </p-button>
                  </div>
                  <div class="text-orange-500 text-sm mt-2">
                    <i class="pi pi-info-circle mr-1"></i>
                    These tools are for development and testing purposes only.
                  </div>
                </div>
              </div>
            </p-panel>

            <p-panel header="DEV Panel - JSON Data" styleClass="mt-3" class="w-full" *ngIf="showDevPanel">
              <pre style="word-break: break-all;white-space: break-spaces">{{ saveInvoiceRequest | json }}</pre>
          </p-panel>

          </div>
      </div>

    </div>
    <ng-template #spinner>
      <p-progressSpinner></p-progressSpinner>
    </ng-template>
</div>

<!-- Add Missing SUREPARK Contacts Dialog -->
<p-dialog
  [(visible)]="showAddMissingContactsDialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  header="Add Missing SUREPARK Members to ParkPro"
  [style]="{width: '50vw'}"
  [dismissableMask]="true">

  <div class="mb-3">
    <p class="text-gray-600 mb-3">
      The following SUREPARK members are not found in ParkPro contacts.
      Select the members you want to add as ParkPro contacts.
    </p>

    <!-- Select All Checkbox -->
    <div class="mb-3 flex align-items-center gap-2">
      <p-checkbox
        [(ngModel)]="selectAllMissing"
        (onChange)="toggleSelectAll($event)"
        binary="true"
        inputId="select-all">
      </p-checkbox>
      <label for="select-all" class="cursor-pointer">Select All</label>
    </div>

    <!-- Missing Members List -->
    <div class="border-1 border-round surface-border">
      <div *ngFor="let member of missingSureparkMembers; let i = index"
           class="p-3 border-bottom-1 surface-border hover:surface-hover">
        <div class="flex align-items-start gap-3">
          <p-checkbox
            [(ngModel)]="selectedMissingMembers[i]"
            binary="true"
            [inputId]="'member-' + i">
          </p-checkbox>

          <div class="flex-1">
            <div class="font-semibold mb-1">
              {{ member.firstName }} {{ member.lastName }}
            </div>

            <div class="text-sm text-gray-600 grid">
              <div *ngIf="member.email" class="col-12 md:col-6">
                <i class="pi pi-envelope mr-2"></i>{{ member.email }}
              </div>
              <div *ngIf="member.telephone" class="col-12 md:col-6">
                <i class="pi pi-phone mr-2"></i>{{ member.telephone }}
              </div>

              <!-- Display Keycards -->
              <div *ngIf="getMemberKeycards(member).length > 0" class="col-12">
                <i class="pi pi-id-card mr-2"></i>
                <span class="mr-2">Keycards:</span>
                <p-tag *ngFor="let keycard of getMemberKeycards(member)"
                       [value]="keycard"
                       severity="secondary"
                       class="mr-1">
                </p-tag>
              </div>

              <!-- Display Vehicles -->
              <div *ngIf="getMemberVehicles(member).length > 0" class="col-12">
                <i class="pi pi-car mr-2"></i>
                <span class="mr-2">Vehicles:</span>
                <p-tag *ngFor="let vehicle of getMemberVehicles(member)"
                       [value]="vehicle"
                       severity="info"
                       class="mr-1">
                </p-tag>
              </div>

              <!-- Display Status and Termination Info -->
              <div class="col-12 md:col-6">
                <i class="pi pi-info-circle mr-2"></i>
                <span class="mr-2">Status:</span>
                <p-tag [value]="member.active ? 'Active' : 'Inactive'"
                       [severity]="member.active ? 'success' : 'danger'"
                       class="mr-1">
                </p-tag>
              </div>

              <div *ngIf="member.endValidity" class="col-12 md:col-6">
                <i class="pi pi-calendar mr-2"></i>
                <span class="mr-2">End Date:</span>
                <span>{{ member.endValidity | date:'shortDate' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rate Selection -->
    <div class="mt-3">
      <label for="default-rate" class="block mb-2">Default Rate for New Contacts:</label>
      <p-dropdown
        id="default-rate"
        [(ngModel)]="selectedDefaultRate"
        [options]="availableRates"
        optionLabel="description"
        optionValue="code"
        placeholder="Select a rate"
        [style]="{width: '100%'}"
        appendTo="body">
          <ng-template let-rate pTemplate="selectedItem">
            <div class="flex align-items-center gap-2">
                <div>{{ rate.description }} ({{ rate.unitprice }})</div>
            </div>
        </ng-template>
        <ng-template let-rate pTemplate="item">
            <div class="flex align-items-center gap-2">
                <div>{{ rate.description }} ({{ rate.unitprice }})</div>
            </div>
        </ng-template>
      </p-dropdown>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      [outlined]="true"
      (click)="showAddMissingContactsDialog = false"
      [disabled]="addingMissingContacts">
    </p-button>
    <p-button
      label="Add Selected Contacts"
      icon="pi pi-plus"
      (click)="addSelectedMissingContacts()"
      [loading]="addingMissingContacts"
      [disabled]="!hasSelectedMembers() || !selectedDefaultRate">
    </p-button>
  </ng-template>
</p-dialog>
